import { IParsedDictionary } from './dictionary';

export const mapValuesWithDictionariesHelper = (
  values: { key: string; value: string }[],
  dictionaries: { [key: string]: IParsedDictionary | any },
) =>
  values.map((item) => {
    if (Array.isArray(item.value) && item.value.length) {
      let valuesInString = '';
      item.value.map((val) => {
        valuesInString = valuesInString
          ? `${valuesInString}, ${dictionaries[item.key]?.[val] ?? val}`
          : (dictionaries[item.key]?.[val] ?? val);
      });
      item.value = valuesInString;
    }

    if (dictionaries?.[item.key] && dictionaries[item.key]?.[item.value]) {
      item.value = dictionaries[item.key]?.[item.value];
    }
    return item;
  });
